import { View } from 'react-native'
import styled, { useTheme } from 'styled-components'
import TouchableNoFeedback from '@flix/common/elements/controls/TouchableNoFeedback/TouchableNoFeedback'
import Image from '@flix/common/elements/images/Image/Image'
import { useLayout } from '@flix/common/elements/layout'
import { Text } from '@flix/common/elements/typography'
import { useMediaIs } from '@flix/common/style/media'

const Card = styled(TouchableNoFeedback)`
  flex-direction: row;
  background: rgba(0, 0, 0, 0.7);
  margin-right: ${(props) => props.theme.spacing.xs}px;
  height: 100%;
`

const Description = styled(View)`
  padding: ${(props) => props.theme.spacing.sm}px;
  width: ${(props) => props.width}px;
`

const Name = styled(Text)`
  font-size: ${(props) => props.fontSize}px;
  margin-bottom: ${(props) => props.theme.spacing.xsmall}px;
`

const Role = styled(Name)`
  color: #ababab;
`

const FeaturedActorCard = ({ slug, title, role, publicId, onActorSelect }) => {
  const { onLayout, height: cardHeight } = useLayout()
  const theme = useTheme()
  const atLeastTablet = useMediaIs('sm')

  const fontSize = Math.min(
    Math.round(cardHeight * 0.18),
    theme.fontSizes[atLeastTablet ? 'large' : 'medium'],
  )
  return (
    <Card onLayout={onLayout} onPress={() => onActorSelect(slug)}>
      {!!cardHeight && <Image publicId={publicId} width={cardHeight / 1.5} height={cardHeight} />}

      <Description width={fontSize * 10}>
        <Name fontSize={fontSize}>{title}</Name>
        <Role fontSize={fontSize}>{role}</Role>
      </Description>
    </Card>
  )
}

export default FeaturedActorCard
